
import { Link } from 'react-router-dom';

interface EventTestimonialProps {
  quote: string;
  author: string;
  role: string;
  category: string;
}

export default function EventTestimonial({ quote, author, role, category }: EventTestimonialProps) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-14 h-14 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-8">
            <i className="ri-double-quotes-l text-2xl text-emerald-600"></i>
          </div>
          <blockquote className="text-xl md:text-2xl font-serif text-stone-700 leading-relaxed italic mb-8">
            &ldquo;{quote}&rdquo;
          </blockquote>
          <div>
            <p className="text-stone-900 font-semibold text-sm">{author}</p>
            <p className="text-stone-400 text-sm mt-1">{role}</p>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center pt-12 border-t border-stone-100">
          <p className="text-stone-500 mb-2 text-sm">Inspired by this {category.toLowerCase()} event?</p>
          <h3 className="text-2xl font-display text-stone-900 mb-6">
            Let\u2019s Create Something <span className="italic text-stone-400">Extraordinary</span>
          </h3>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/#inquiry"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-gradient-to-r from-emerald-600 to-teal-500 text-white text-sm font-semibold rounded-full hover:from-emerald-500 hover:to-teal-400 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-emerald-500/20"
            >
              <i className="ri-chat-1-line"></i>
              Get a Quote
            </Link>
            <Link
              to="/#portfolio"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-stone-100 text-stone-700 text-sm font-semibold rounded-full hover:bg-stone-200 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-gallery-line"></i>
              View More Events
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
